import {
  base_colorContentBorder,
  text_colorTextPrimary,
  text_colorTextSecondary,
} from 'ext-ui/style/colors'
import { spacing } from 'ext-ui/style/spacing'
import { font_size_md, fontH3 } from 'ext-ui/style/typography'
import { css } from 'styled-components'

export default css`
  width: fit-content;
  &.ManageSubscriptionPromoCard {
    & .card-title-row {
      vertical-align: baseline;
      margin-bottom: ${spacing(7)};
      .card-title {
        ${fontH3};
        color: ${text_colorTextPrimary};
        margin-right: ${spacing(2)};
      }
      .card-title-pill {
        display: inline-flex;

        vertical-align: text-top;
      }
    }

    & .hero {
      overflow: hidden;
      border-radius: 10px;
      margin-bottom: ${spacing(10)};
    }

    & .header-border {
      border-bottom: 1px solid ${base_colorContentBorder};
      margin-bottom: ${spacing(5)};
    }

    & .card-disclaimer {
      margin-top: ${spacing(3)};
      font-size: ${font_size_md};
      color: ${text_colorTextSecondary};

      .underline-link {
        text-decoration: underline;
      }
    }
  }
`
